@import '../../../node_modules/prismjs/themes/prism.css';

:host {

  .code-wrapper {
    display: block;
    position: relative;

    .copy-icon {
      padding: 8px;
      background-color: darken(#f7f7f7, 5%);
      border-radius: 0 0 0 3px;
      border: 1px solid darken(#f7f7f7, 8%);
      position: absolute;
      top: 0;
      right: 0;

      &:hover {
        cursor: pointer;
        background-color: darken(#f7f7f7, 9%);
      }
    }

    code {
      display: block;
      background-color: #fdfdfd;
      border: 1px solid #dedede;
      padding: 1em 2em 1em 1em;
      border-radius: 3px;
      margin-top: 1em;
      margin-bottom: 1em;
      word-wrap: normal;
      overflow-x: scroll;

      &.muted {
        font-size: 12px;
        font-family: Consolas, 'Liberation Mono', Menlo, Courier, monospace;
      }
    }
  }

  .inline {
    font-size: 0.85em;
    pre { display: inline; }
    &.property { pre { code { color: green; } } }
    &.boolean { pre { code { color: darkred; } } }
    &.string { pre { code { color: darkolivegreen; } } }
    &.number { pre { code { color: darkslateblue; } } }
    &.function { pre { code { color: darkmagenta; } } }
    pre { code { color: #4f4f4f; } }
  }
}
